//This file is generated from c# do not modify, any changes will be overridden when re-generated.
import { ModelBase } from "../../pillar/common/models/ModelBase";
import { OptionModel } from './OptionModel';

export class ExtractModel extends ModelBase {
  static readonly $typeName = 'ExtractModel';
  public permission: string;
  public name: string;
  public displayName: string;
  public displayedExtractColumns: string[];
  public options: OptionModel<any>[];
}



// WEBPACK FOOTER //
// ./src/app/extracts/models/ExtractModel.ts